import styled, { css } from 'styled-components';
import CustomDropdown from '../dropdown/CustomDropDown';

export const CustomDropdownStyle = styled(CustomDropdown)`
  background-color: ${({ theme }) => theme.white};
  border: 1px solid
    ${({ theme, invalid }) => (invalid ? theme.danger4 : theme.lightGray1)};
  border-radius: ${({ size }) => (size === 'small' ? '4px' : '8px')};
  width: 100%;
  &.new-font {
    border: 1.5px solid
      ${({ theme, invalid }) => (invalid ? theme.error : theme.dark70)};
    &.show {
      border-color: ${({ theme }) => theme.primary};
    }
  }
  &.table-dropdown-custom {
    h6 {
      color: ${({ theme }) => theme.grayNew};
      &.empty-dropdown {
        color: ${({ theme }) => theme.gray40};
      }
    }
    .menu-dropdown {
      min-width: ${({ dropDownMaxWidth }) => dropDownMaxWidth ?? '19rem'};
      inset: 10px 0 auto 0 !important;
      &[data-popper-placement='top-start'] {
        inset: auto auto 0 0 !important;
      }
      &.new-menu {
        position: relative;
        border: 1px solid ${({ theme }) => theme.dark40} !important;
        background-color: ${({ theme }) => theme.white};
        box-shadow: 0 8px 16px 0 #00000014, 0 0 4px 0 #0000000a;
        padding: 24px !important;
        border-radius: 8px;

        &::before {
          content: '';
          position: absolute;
          top: -7px;
          right: 23px;
          width: 13px;
          height: 13px;
          border: 1.5px solid ${({ theme }) => theme.dark40};
          border-bottom: 0;
          border-right: 0;
          background: ${({ theme }) => theme.white};
          border-top-left-radius: 3px;
          transform: rotate(45deg);
        }
        &.filter-dropdown {
          min-width: 398px;
          ${({ theme }) => css`
            @media (max-width: ${theme?.breakpoints?.md}px) {
              min-width: auto;
            }
          `}
        }
      }
      &.checkbox-dropdown {
        border: 1.5px solid ${({ theme }) => theme.primary} !important;
        top: 8px !important;
        box-shadow: none !important;
        padding-bottom: 5px !important;
      }
      &.website-filter-dropdown {
        inset: -15px 4px auto auto !important;
        min-width: 25rem;
      }
    }
  }
  .table-dropdown {
    flex-wrap: nowrap !important;
    &.table-text {
      padding: ${({ size }) => (size === 'small' ? '6px 8px' : '9px 5px')};
      h6 {
        font-size: 14px;
        font-weight: normal;
        color: ${({ theme }) => theme.primaryDark};
      }

      ${({ theme }) => css`
        @media (max-width: ${theme?.breakpoints?.sm}px) {
          padding: 9px 5px;
        }
      `}
      &.new-font {
        h6 {
          font-size: 18px;
          font-weight: 400;
          color: ${({ theme, value }) => (value ? theme.dark40 : theme.dark60)};
          font-family: ${({ theme }) => theme.fontFamily};
        }
        svg {
          color: ${({ theme }) => theme.icon}!important;
        }
      }
    }
    &.menu-toggle {
      background-color: transparent;
      border: 0;
      width: 100%;
      height: ${({ size }) => (size === 'small' ? 'fit-content' : '48px')};
      border-radius: 4px;
      &.show,
      &:hover,
      &:focus {
        background-color: transparent;
      }
      &.new-font {
        height: 45px;
        svg {
          color: ${({ theme }) => theme.icon}!important;
        }
      }
    }
    .filter-dropdown {
      min-width: 325px !important;
      padding: 24px 24px 12px 24px !important;
      border-radius: 14px !important;
    }
    .topic-filter-menu {
      max-height: 480px;
      overflow-y: auto;
      padding-bottom: 0 !important;
      padding-top: 0 !important;
      .topicFilterHeading {
        padding-top: 24px;
        position: sticky;
        top: 0;
        z-index: 99;
        background-color: ${({ theme }) => theme.white};
      }
      .filterFooter {
        padding-bottom: 12px;
        position: sticky;
        bottom: 0px;
        background-color: ${({ theme }) => theme.white};
      }
    }

    svg {
      ${({ size }) => (size === 'small' ? 'height: 20px; width: 20px;' : '')}
    }
    .place-holder {
      //styleName: Body Copy 1;
      font-family: ${({ theme }) => theme.fontFamily};
      font-size: 18px;
      font-weight: 400;
      line-height: 29px;
      letter-spacing: 0;
      text-align: left;
      color: ${({ theme }) => theme.dark60};
      &.has-value {
        color: ${({ theme }) => theme.dark40};
      }
    }
  }
`;

export const StyledCustomDropdown = {
  CustomDropdownStyle,
};
